import Trans from 'next-translate/Trans'
import { MYBOARD_UPDATE_TRACKED_BY } from 'tennders-stracture/libs/permissions'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import GHref from 'tennders-market/common/components/element/GHref'
import { RowPropsTransaction } from 'tennders-market/bin/components/row/RowProps'
import useAssignTo from 'tennders-transactions/hooks/useAssignTo'
import useTranslation from 'next-translate/useTranslation'
import { STATUS_CANCELLED } from 'tennders-stracture/libs/constants'
import IconAssignTracker from '../../../../../../icons/icon-assign-tracker.svg'

const RowAssignTrackerAction = ({ transaction, color, isBrokerRowDisplay }:RowPropsTransaction) => {
  const { setAssignTo: setAssignToTracker } = useAssignTo('tracker', false)
  const { t } = useTranslation()

  if (transaction?.status?.label === STATUS_CANCELLED) {
    return null
  }

  const fallBack = (
    <GHref
      className={`bg-dark d-flex col flex-center text-center disabled${transaction?.trackedBy?.name ? '' : ' attention-text'}`}
      tip={t('tableRow:noPermission')}
    >
      <IconAssignTracker />
      <div className="icon-label">
        <Trans i18nKey="common:tracker" />
      </div>
    </GHref>
  )

  return (
    <div className="text-center">
      <RequiresPermission
        fallbackComponent={fallBack}
        requiredPermissions={[
          MYBOARD_UPDATE_TRACKED_BY
        ]}
      >
        <GHref
          className={`bg-dark d-flex col flex-center${isBrokerRowDisplay ? ' btn standard-btn p-4' : ''}${transaction?.trackedBy?.name ? '' : ' attention-text'}`}
          onClick={() => setAssignToTracker(transaction?.id)}
        >
          {isBrokerRowDisplay
            ? (
              <div className="d-flex align-center justify-space ">
                <span>{`${transaction?.trackedBy?.name || 'No Tracker'}`}</span>
                <IconAssignTracker />
              </div>
            )
            : (
              <>
                <IconAssignTracker />
                <div className="icon-label" style={{ color }}>
                  <Trans i18nKey="common:tracker" />
                </div>
              </>
            )}
        </GHref>
      </RequiresPermission>
    </div>
  )
}

export default RowAssignTrackerAction
